class RoutesPath {
    static HOME = { NAME: 'Home', PATH: '/' };

    static EXAMPLE_PAGE = { NAME: 'Example Page', PATH: '/example' };

    static SETTINGS_PAGE = { NAME: 'Configurações', PATH: '/settings' };
}

export default RoutesPath;
